import { jsx } from "react/jsx-runtime";
import { useMemo, useContext, createContext } from "react";
import { useConversationState } from "./hooks/useConversationState.js";
const ConciergeContext = createContext(void 0);
const useConciergeContext = () => {
  const context = useContext(ConciergeContext);
  if (!context) {
    throw new Error("useConciergeContext must be used within ConciergeContextProvider");
  }
  return context;
};
const ConciergeContextProvider = ({
  children,
  apiBaseUrl,
  isSignedIn,
  retailerIdToNameMap,
  inlineSignIn,
  inlineVerifyOtp
}) => {
  const conversationState = useConversationState();
  const contextValue = useMemo(
    () => ({ ...conversationState, apiBaseUrl, isSignedIn, retailerIdToNameMap, inlineSignIn, inlineVerifyOtp }),
    // Individual state values (not the parent object) so the memo only invalidates
    // when an actual piece of data changes, not on every parent re-render.
    [
      conversationState.conversationId,
      conversationState.setConversationId,
      conversationState.sharedConversationId,
      conversationState.setSharedConversationId,
      conversationState.conversationHistory,
      conversationState.setConversationHistory,
      conversationState.isActivelyStreaming,
      conversationState.setIsActivelyStreaming,
      conversationState.streamingAIResponse,
      conversationState.setStreamingAIResponse,
      conversationState.searchAngleDetails,
      conversationState.setSearchAngleDetails,
      conversationState.followUpQuestions,
      conversationState.setFollowUpQuestions,
      conversationState.streamingStoreLocator,
      conversationState.setStreamingStoreLocator,
      conversationState.streamingDevInfo,
      conversationState.setStreamingDevInfo,
      conversationState.clearStreamingState,
      conversationState.conversationPageContext,
      conversationState.setConversationPageContext,
      conversationState.isSharedView,
      conversationState.setIsSharedView,
      conversationState.sharedByUserName,
      conversationState.setSharedByUserName,
      conversationState.sharedAtMessageIndex,
      conversationState.setSharedAtMessageIndex,
      conversationState.sourceConversationId,
      conversationState.setSourceConversationId,
      conversationState.sourceCheckpointIndex,
      conversationState.setSourceCheckpointIndex,
      conversationState.pendingShareConversationId,
      conversationState.setPendingShareConversationId,
      apiBaseUrl,
      isSignedIn,
      retailerIdToNameMap,
      inlineSignIn,
      inlineVerifyOtp
    ]
  );
  return /* @__PURE__ */ jsx(ConciergeContext.Provider, { value: contextValue, children });
};
export {
  ConciergeContextProvider,
  useConciergeContext
};
//# sourceMappingURL=ConciergeContextProvider.js.map
